"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFilled = void 0;
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
var StyledSelect = styled_components_1.default(antd_1.Select)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  & .ant-select-selector {\n    background-color: ", " !important;\n  }\n"], ["\n  & .ant-select-selector {\n    background-color: ", " !important;\n  }\n"])), function (props) { return props.$backgroundColor; });
var SelectFilled = function (_a) {
    var _b, _c, _d;
    var options = _a.options, value = _a.value, suffixIcon = _a.suffixIcon, props = __rest(_a, ["options", "value", "suffixIcon"]);
    var optionsMap = react_1.useMemo(function () {
        return options === null || options === void 0 ? void 0 : options.reduce(function (prevObj, currentValue) {
            var _a;
            return (__assign(__assign({}, prevObj), (_a = {}, _a[currentValue.value] = {
                label: currentValue.label,
                optLabel: currentValue.optLabel,
                colors: currentValue.colors,
            }, _a)));
        }, {});
    }, [options]);
    return (react_1.default.createElement(StyledSelect, __assign({}, props, { value: value, optionLabelProp: "optLabel", "$backgroundColor": (_c = (_b = optionsMap === null || optionsMap === void 0 ? void 0 : optionsMap[value]) === null || _b === void 0 ? void 0 : _b.colors.secondary) !== null && _c !== void 0 ? _c : "transparent", options: options === null || options === void 0 ? void 0 : options.map(function (opt) {
            var _a;
            return ({
                label: opt.label,
                value: opt.value,
                optLabel: (_a = opt.optLabel) !== null && _a !== void 0 ? _a : opt.label,
            });
        }), suffixIcon: suffixIcon === null || suffixIcon === void 0 ? void 0 : suffixIcon((_d = optionsMap === null || optionsMap === void 0 ? void 0 : optionsMap[value]) === null || _d === void 0 ? void 0 : _d.colors) })));
};
exports.SelectFilled = SelectFilled;
var templateObject_1;
